import { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ProfileContext } from 'components/Profile/ProfileContext'
import { AppIsInTestEnvironment } from 'functions/environmentUtils'
import { WeekOfTheYearKey } from 'classes/WeekOfTheYearKey'
import { TEST_setPresentDate, TEST_setPresentWeekOfTheYearKey } from 'redux/slices/athleteProfile'
import moment from 'moment'

import OutlineButton from 'components/Buttons/OutlineButton'

export default function ProgramDateAdjustmentController() {

    const dispatch = useDispatch()
    const trainingChartPresentDate = useSelector(state => state.athleteProfile.trainingChartPresentDate)

    const { ReloadTrainingChartData } = useContext(ProfileContext)
    
    const simulatorOptions = [
        {
            text: '-1 week',
            onClick: () => UpdatePresentDate(-7),
        },
        // {
        //     text: '-1 day',
        //     onClick: () => UpdatePresentDate(-1),
        // },
        // {
        //     text: '+1 day',
        //     onClick: () => UpdatePresentDate(1),
        // },
        {
            text: '+1 week',
            onClick: () => UpdatePresentDate(7),
        }
    ]

    const UpdatePresentDate = (value) => {
        const newTrainingChartPresentDate = moment(trainingChartPresentDate).add(value, 'days').format('YYYY-MM-DD')
        const newTrainingChartPresentWeekOfTheYearKey = new WeekOfTheYearKey(moment(newTrainingChartPresentDate)).toString()

        dispatch(TEST_setPresentDate(newTrainingChartPresentDate))
        dispatch(TEST_setPresentWeekOfTheYearKey(newTrainingChartPresentWeekOfTheYearKey))
        
        console.log('Updated week by ' + value + ' days')
        console.log('New present date: ' + newTrainingChartPresentDate)
        console.log('New week of the year key: ' + newTrainingChartPresentWeekOfTheYearKey.toString())

        ReloadTrainingChartData(newTrainingChartPresentDate)
    }

    if (AppIsInTestEnvironment() === false) {
        return null
    }

    return (
        <>
            {simulatorOptions.map((option, index) => (
                <div 
                    key={index} 
                    className='w-16 2xl:w-20'
                >
                    <OutlineButton
                        text={option.text}
                        size='extra-small'
                        className="hover:bg-gray-50 outline-none"
                        action={option.onClick}
                    />
                </div>
            ))}
        </>
    )
}